import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { useFeatureFlag } from "../../../../../hooks/useFeatureFlag";
import { useOfferApprovals } from "../../../../../data/useCallQueue";

// Shown to agents who can approve offers, on the dashboard home and the Quotes page. The count is 0
// for everyone else, so nobody else ever sees it.
export default function ApprovalsBanner() {
  const { t } = useTranslation("leads");
  const isCallCentre = useFeatureFlag("Call Centre");
  const { pendingCount } = useOfferApprovals(isCallCentre, false, "ApprovalsBanner");
  const count = pendingCount.data?.data ?? 0;

  if (!isCallCentre || count === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      <ExclamationTriangleIcon className="h-5 w-5 flex-none" aria-hidden="true" />
      <span className="flex-1 font-medium">
        {count === 1
          ? t("1 offer is waiting for your approval")
          : t("{{count}} offers are waiting for your approval", { count })}
      </span>
      <Link to="/quotes?view=all&tab=manager" className="font-semibold underline">
        {t("Review")}
      </Link>
    </div>
  );
}
